import { Box } from '@chakra-ui/react';

import style from './VendorLoginSection.style';
import { VendorLoginSectionProps } from './VendorLoginSection.type';

import { ContentfulRichText } from '@/components';

const VendorLoginSection = ({
  mainTitle,
  description,
}: VendorLoginSectionProps) => {
  return (
    <Box __css={style.contentSide}>
      {mainTitle && <ContentfulRichText document={mainTitle} />}
      {description && <ContentfulRichText document={description} />}
    </Box>
  );
};

export default VendorLoginSection;
